import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { useEffect } from "react"
import { formatterDate, getNotificationLabelByValue, } from "../../../utils"
import { addDays } from "date-fns"

export function MonitoringM24OpenList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const m24Open = useAppSelector(state => state.m24Open)

    return (
        <div className="mt-6">
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}>Apri</th>
                        <th>SOT</th>
                        <th>Regione</th>
                        <th>Cod. Op</th>
                        <th>Ciente</th>
                        <th>Data Ingresso</th>
                        <th>Data Fine</th>
                        <th>Tipologia M24</th>
                        <th>Data Valutazione</th>
                        <th>Utente Val.</th>
                        <th>Abilitazione Utente (OCD)Al Riesame</th>
                        <th>Utenti (OCD) non autorizzati  al Riesame/Decisione</th>
                        <th>Data Riesame</th>
                        <th>Utente Riesame</th>
                        <th>Data Decisione</th>
                        <th>Utente Decisione</th>
                        <th>M29</th>
                        <th>Data Inizio M29</th>
                        <th style={{ borderTopRightRadius: '8px' }}>Data Fine M29</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        m24Open.GetAllM24OpenResponse?.map((fs, index) => (
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>{fs.customerRegion}</td>
                                <td>{fs.customerHeadQuarters}</td>
                                <td>{fs.customerClientCode}</td>
                                <td>{fs.customerCompanyName}</td>
                                <td>{formatterDate(fs.startingDate)}</td>
                                <td>{formatterDate(fs.endingDate)}</td>
                                <td></td>
                                <td>{formatterDate(addDays(new Date(fs.startingDate), 90))}</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                        ))}

                </tbody>
            </table>
        </div>
    )
}